import { render, staticRenderFns } from "./AttachmentsWorkorder.vue?vue&type=template&id=4fda2b11"
import script from "./AttachmentsWorkorder.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsWorkorder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports